module.exports = __webpack_public_path__ + "static/ClickedDamageLoss-61b03a23132228416cd8d554a4b549a1.png";